import { DatePicker } from "antd";
import type { Moment } from "moment";
import momentGenerateConfig from "rc-picker/lib/generate/moment";

export const DatePickerMoment = DatePicker.generatePicker<Moment>(momentGenerateConfig);
